import { getBrowserInfo, getOsInfo, isMinimumBrowserVersion } from 'owa-user-agent';
import {
    BrowserVersion,
    BrowserVersionRange,
    SupportedBrowserConfig,
} from '../schema/A2HSCampaignProvider.types';

/**
 * Tells whether user's browser is supported for A2HS campaign based on
 * supported browsers configurations
 * @param supportedBrowserConfigs  Configurations of supported browsers
 */
export const isUserBrowserSupportedForA2HSCampaign = (
    supportedBrowserConfigs: SupportedBrowserConfig[]
): boolean => !!supportedBrowserConfigs.find(doesUserBrowserMatchSupportedBrowserConfig);

export const doesUserBrowserMatchSupportedBrowserConfig = (
    supportedBrowserConfig: SupportedBrowserConfig
): boolean => {
    const {
        browserName: supportedBrowserName,
        browserVersionRange: supportedVersionRangeForBrowser,
        operatingSystems: supportedOSsForBrowser,
    } = supportedBrowserConfig;

    const { browser: userBrowserName } = getBrowserInfo();
    const { os: userOS } = getOsInfo();

    if (userBrowserName !== supportedBrowserName) {
        return false;
    }

    if (!supportedOSsForBrowser.includes(userOS)) {
        return false;
    }

    return isUserBrowserVersionInSupportedVersionRange(supportedVersionRangeForBrowser);
};

export const isUserBrowserVersionInSupportedVersionRange = (
    supportedVersionRange: BrowserVersionRange
) => {
    if (!supportedVersionRange?.length) {
        // All versions supported
        return true;
    }

    if (isGreaterThanOrEqualRange(supportedVersionRange)) {
        const minimumSupportedVersion = supportedVersionRange;
        return isMinimumBrowserVersion(minimumSupportedVersion);
    }

    const minimumSupportedVersion = supportedVersionRange[0];
    const minimumDeprecatedVersion = supportedVersionRange[1];

    return (
        isMinimumBrowserVersion(minimumSupportedVersion) &&
        !isMinimumBrowserVersion(minimumDeprecatedVersion)
    );
};

export const isGreaterThanOrEqualRange = (
    browserVersionRange: BrowserVersionRange
): browserVersionRange is BrowserVersion => typeof browserVersionRange?.[0] === 'number';
